/*
 * @Description: '产品中心'页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2019-07-26 16:48:59
*/

export default [
   
    {
        path: '/solution/chongdianzhukong',
        component: resolve => require(['@/views/solution/chongdianzhukong'], resolve),
        name: 'chongdianzhukong',
        meta: {
            nav: '充电主控方案'
        }
    },
    {
        path: '/solution/gonggongkuaichong',
        component: resolve => require(['@/views/solution/gonggongkuaichong'], resolve),
        name: 'gonggongkuaichong',
        meta: {
            nav: '公共快充解决方案'
        }
    },
    {
        path: '/solution/shangyedichan',
        component: resolve => require(['@/views/solution/shangyedichan'], resolve),
        name: 'shangyedichan',
        meta: {
            nav: '商业地产充电解决方案'
        }
    },
    {
        path: '/solution/teshuchangjing',
        component: resolve => require(['@/views/solution/teshuchangjing'], resolve),
        name: 'nslp',
        meta: {
            nav: '特殊场景充电解决方案'
        }
    },

]



// WEBPACK FOOTER //
// ./src/router/product.js